<template>
    <tr>
        <td class="text-nowrap">
            <div class="d-flex gap-2 align-items-center">
                <div v-if="item.profilePictureUrl">
                    <img :src="avatarImage" alt="Profile Picture" class="profile-avatar shadow-lg me-1" />
                </div>
                <div v-else class="default-avatar shadow-lg me-1">
                    <span class="avatar-letter">{{ avatarLetter }}</span>
                </div>
                <div>
                    <p class="m-0 fw-bold text-left">
                        {{ item.firstName }} {{ item.lastName }}
                    </p>
                    <p class="my-0">
                        {{ item.email }}
                    </p>
                </div>
            </div>
        </td>
        <td>{{ parseDateLong(item.dateCreated) }}</td>
        <td>
            <template v-if="item.status === 'Approved'">
                <MDBBadge class="bg-success text-white px-3" style="font-size: 13px;">Approved</MDBBadge>
            </template>
            <template v-else-if="item.status === 'Pending'">
                <MDBBadge class="bg-warning text-white px-3" style="font-size: 13px;">Pending</MDBBadge>
            </template>
            <template v-else>
                <MDBBadge class="bg-danger text-white px-3" style="font-size: 13px;">Rejected</MDBBadge>
            </template>
        </td>
        <td class="text-nowrap">
            <MDBTooltip v-model="tootltipModal">
                <template #reference>
                    <button type="button" @click.stop="fetchWithdrawDetails(item)"
                        class="btn-md border-0 bg-transparent primary-text" data-mdb-ripple-init data-mdb-modal-init
                        data-mdb-target="#viewModal">
                        <i class="fas fa-file-text fa-lg pe-none"></i>
                    </button>
                </template>
                <template #tip>View Details</template>
            </MDBTooltip>
        </td>
    </tr>
    <MDBModal id="viewModal" tabindex="1" labelledby="viewModal" v-model="viewModal" staticBackdrop scrollable>
        <template v-if="currentStep == 'main'">
            <MDBModalHeader class="px-4">
                <div class="d-block">
                    <template v-if="item.status === 'Pending'">
                        <MDBModalTitle id="withdrawModal" class="text-black fw-bold">Withdraw Request Details
                        </MDBModalTitle>
                        <p class="mb-0">Review withdrawal request information before taking
                            action</p>
                    </template>
                    <MDBModalTitle v-else id="withdrawModal" class="text-black fw-bold">Withdraw Request <span
                            class="fw-bold" style="color: var(--primary);">{{
                                item.status }}
                        </span></MDBModalTitle>
                </div>
            </MDBModalHeader>
            <MDBModalBody class="p-4 pt-2">
                <MDBTabs v-model="tabs">
                    <MDBTabNav fill tabsClasses="mb-3 sticky-top bg-white">
                        <MDBTabItem tabId="receipt" href="receipt" class="fw-bold">Receipt</MDBTabItem>
                        <MDBTabItem tabId="history" href="history" class="fw-bold">History Log</MDBTabItem>
                    </MDBTabNav>
                    <MDBTabContent>
                        <MDBTabPane tabId="receipt">
                            <div class="mb-4">
                                <h6>Reference Code</h6>
                                <h5 class="fw-bold">{{ item.referenceCode }}</h5>
                                <h6 style="font-size: 14px;">NOTE: This is the unique reference code for your
                                    transaction. Keep
                                    it
                                    handy
                                    for
                                    any inquires or
                                    support
                                    related to this transaction.</h6>
                            </div>
                            <div class="border rounded-5 p-4">
                                <h6>Date Applied</h6>
                                <h5 class="fw-bold">{{ parseDateLong(item.dateCreated) }}</h5>
                                <hr>
                                <div>
                                    <h6 class="fw-bold" style="font-size: 12px;">User Information</h6>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="fs-7">Name</h6>
                                        <h6 class="fs-7 fw-bold">{{ item.firstName }} {{ item.lastName }}</h6>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="fs-7">Email</h6>
                                        <h6 class="fs-7 fw-bold">{{ item.email }}</h6>
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <h6 class="fw-bold" style="font-size: 12px;">Withdraw Amount Breakdown</h6>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="fs-7">Requested Amount</h6>
                                        <h6 class="fs-7 fw-bold">${{ addCommaNumbers(item.amount) }}</h6>
                                    </div>
                                    <!-- <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="fs-7">Fee</h6>
                                        <h6 class="fs-7 fw-bold">2.5%</h6>
                                    </div> -->
                                </div>
                                <hr>
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="fs-7">Total Amount to be Deducted</h6>
                                    <h6 class="fs-7 fw-bold">${{ addCommaNumbers(item.amount) }}</h6>
                                </div>
                            </div>
                        </MDBTabPane>
                        <MDBTabPane tabId="history">
                            <div v-if="withdrawLogs.length > 0" class="position-relative">
                                <div v-for="(log, index) in sortedwithdrawLogs" :key="log.id"
                                    class="mb-4 position-relative">
                                    <span class="position-absolute translate-middle rounded-circle"
                                        style="width: 12px; height: 12px; top: 25%; left: 2%; background-color: var(--primary);"></span>

                                    <div v-if="index !== sortedwithdrawLogs.length - 1" class="position-absolute"
                                        style="top: 20px; bottom: -22px; width: 2px; background-color: #dee2e6; left: 1.6%;">
                                    </div>

                                    <div class="ms-4">
                                        <div class="d-flex justify-content-between">
                                            <div class="fw-bold">
                                                {{ Number(userDetail.id) != log.createdByUserId
                                                    ? log.createdByFullName
                                                    : "VVV Admin" }}
                                            </div>
                                            <small class="text-muted">
                                                {{ new Date(log.dateCreated).toLocaleString() }}
                                            </small>
                                        </div>
                                        <div>{{ log.remarks }}</div>
                                        <div class="fs-7">{{ log.referenceCode }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center text-muted">
                                No credit history found.
                            </div>
                        </MDBTabPane>
                    </MDBTabContent>
                </MDBTabs>
            </MDBModalBody>
            <MDBModalFooter v-if="withdrawDetails.status === 'Pending'" class="d-flex gap-2 p-4 align-items-center">
                <MDBBtn class="btn btn-danger" @click="currentStep = 'reject'">
                    <MDBIcon iconStyle="fas" icon="x" class="me-1" />
                    Reject
                </MDBBtn>
                <MDBBtn class="btn btn-success" :disabled="isApproving"
                    @click="updateWithdrawDetails(item.id, 'Approved')">
                    <template v-if="isApproving">
                        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Processing...
                    </template>
                    <template v-else>
                        <MDBIcon iconStyle="fas" icon="check" class="me-1" />
                        Approve
                    </template>
                </MDBBtn>
            </MDBModalFooter>
        </template>
        <template v-else>
            <MDBModalHeader class="px-4">
                <div class="d-block">
                    <MDBModalTitle id="withdrawModal" class="text-black fw-bold">Reject Withdrawal Request
                    </MDBModalTitle>
                </div>
            </MDBModalHeader>
            <MDBModalBody class="p-4">
                <MDBTextarea label="Remarks for rejecting..." rows="4" v-model="remarks" />
            </MDBModalBody>
            <MDBModalFooter class="d-flex gap-2 p-4 align-items-center">
                <MDBBtn class="btn" @click="currentStep = 'main'">
                    <MDBIcon iconStyle="fas" icon="x" class="me-1" />
                    Cancel
                </MDBBtn>
                <MDBBtn class="btn btn-danger" :disabled="isRejecting"
                    @click="updateWithdrawDetails(item.id, 'Rejected')">
                    <template v-if="isRejecting">
                        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Rejecting...
                    </template>
                    <template v-else>
                        <MDBIcon iconStyle="fas" icon="check" class="me-1" />
                        Confirm Reject
                    </template>
                </MDBBtn>
            </MDBModalFooter>
        </template>
    </MDBModal>
</template>

<script setup>
import { parseDateLong } from "@/helpers/parseDate";
import { useUserDetailStore } from "@/store/userDetailStore";
import {
    MDBBadge,
    MDBBtn, MDBIcon,
    MDBModal, MDBModalBody,
    MDBModalFooter,
    MDBModalHeader, MDBModalTitle, MDBTabContent,
    MDBTabItem, MDBTabNav, MDBTabPane, MDBTabs,
    MDBTextarea,
    MDBTooltip
} from "mdb-vue-ui-kit";
import { storeToRefs } from "pinia";
import { computed, defineEmits, defineProps, ref, watch } from "vue";
import { addCommaNumbers } from "../../../helpers/addCommaNumbers";
import { GetTransactionById } from "../../../services/TransactionHistory/GetTransactionById";
import { PutUpdateWithdrawal } from "../../../services/Withdraw/PutUpdateWithdrawal";

const userDetailStore = useUserDetailStore();
const { userDetail } = storeToRefs(userDetailStore)

const props = defineProps({
    item: Object,
    getWithdrawList: Function
});

const emit = defineEmits(["trigger-success-toast", "trigger-error-toast"]);

const viewModal = ref(false);
const tootltipModal = ref(false);
const tabs = ref('receipt')

const avatarLetter = computed(() => {
    return props.item?.firstName?.charAt(0).toUpperCase() || '';
});

const avatarImage = ref(props.item?.profilePictureUrl);
watch(() => props.item?.profilePictureUrl, (newUrl) => {
    avatarImage.value = `${newUrl}&t=${Date.now()}`;
});

const withdrawDetails = ref({})
const withdrawLogs = ref([])
const fetchWithdrawDetails = async (data) => {
    viewModal.value = true
    withdrawDetails.value = data
    try {
        const response = await GetTransactionById(data.id, data.transactionType)
        if (response) {

            if (response && response.length > 0) {
                withdrawLogs.value = response
            }
        }
    } catch (error) {
        console.error(error)
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Failed to fetch withdraw details: ${error}`
        });
    }
}

const sortedwithdrawLogs = computed(() =>
    withdrawLogs.value
        .slice()
        .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
);

const currentStep = ref("main")

const remarks = ref("")
const isApproving = ref(false)
const isDeclining = ref(false)
const isRejecting = ref(false)
const updateWithdrawDetails = async (id, status) => {
    if (status === "Approved") {
        isApproving.value = true
    } else if (status === "Pending") {
        isDeclining.value = true
    } else {
        isRejecting.value = true
    }
    try {
        const payload = {
            createdBy: userDetail.value.id,
            status: status,
            remarks: remarks.value
        }
        await PutUpdateWithdrawal(id, payload)
        viewModal.value = false
        emit("trigger-success-toast", {
            show: true,
            title: "Success",
            message: "Wihdraw details updated successfully."
        });

        props.getWithdrawList()
    } catch (error) {
        console.error(error)
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Failed to update withdraw details: ${error}`
        });
    } finally {
        if (status === "Approved") {
            isApproving.value = true
        } else if (status === "Pending") {
            isDeclining.value = true
        } else {
            isRejecting.value = true
        }
    }
}
</script>

<style scoped>
.btn-primary {
    background-color: var(--primary);
}

.btn-outline-primary {
    border-color: var(--accent);
    color: var(--accent);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    /* width: 30px;
    height: 30px;
    display: grid;
    place-content: center; */
    vertical-align: middle;
}

.btn-outline-primary i {
    vertical-align: top;
}

.default-avatar {
    width: 50px;
    height: 50px;
    background-color: var(--primary);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 22px;
    font-weight: bold;
}

.profile-avatar {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    object-fit: cover;
}

.avatar-letter {
    text-transform: uppercase;
}
</style>

<style>
.tooltip-inner {
    font-family: "Poppins", sans-serif !important;
    background-color: var(--primary);
    font-size: 12px;
    padding: 3px 12px;
}

.badge-dot {
    background-color: var(--primary);
}
</style>
